import { Directive, ElementRef, HostListener, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appHorizontalScroll]'
})
export class HorizontalScrollDirective implements AfterViewInit {

  private hasHorizontalScroll = false;
  private mutationObserver: MutationObserver;
  private leftArrow: HTMLElement;
  private rightArrow: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.createArrows();
      this.checkForScroll();
      this.initMutationObserver();
    }, 500);
  }

  ngOnDestroy() {
    // Clean up the observer when the directive is destroyed
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }

  private initMutationObserver() {
    this.mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          this.checkForScroll();
        }
      });
    });

    // Start observing the element for changes in child elements
    this.mutationObserver.observe(this.el.nativeElement, {
      childList: true,  // Watch for child node additions/removals
      subtree: false     // Watch the entire subtree for changes
    });
  }

  private checkForScroll() {
    const element = this.el.nativeElement;
    this.hasHorizontalScroll = element.scrollWidth > element.clientWidth;

    // Show arrows if there is horizontal scroll
    if (this.hasHorizontalScroll) {
      this.showArrows();
    } else {
      this.hideArrows();
    }
  }

  private createArrows() {
    this.leftArrow = this.renderer.createElement('span');
    this.rightArrow = this.renderer.createElement('span');

    this.leftArrow.innerHTML = '<ion-icon name="arrow-back-circle-outline"></ion-icon>';
    this.rightArrow.innerHTML = '<ion-icon name="arrow-forward-circle-outline"></ion-icon>';

    this.renderer.setStyle(this.leftArrow, 'marginRight', '4px');
    this.renderer.setStyle(this.rightArrow, 'marginLeft', '4px');
    this.renderer.setStyle(this.leftArrow, 'left', '0');
    this.renderer.setStyle(this.rightArrow, 'right', '0');
    this.renderer.setStyle(this.rightArrow, 'top', '0');
    this.renderer.setStyle(this.leftArrow, 'cursor', 'pointer');
    this.renderer.setStyle(this.rightArrow, 'cursor', 'pointer');
    this.renderer.setStyle(this.leftArrow, 'fontSize', '24px');
    this.renderer.setStyle(this.rightArrow, 'fontSize', '24px');
    this.renderer.setStyle(this.leftArrow, 'zIndex', '1000');
    this.renderer.setStyle(this.rightArrow, 'zIndex', '1000');

    this.renderer.listen(this.leftArrow, 'click', () => this.scrollLeft());
    this.renderer.listen(this.rightArrow, 'click', () => this.scrollRight());

    // Insert the left arrow before the first child in the scrollable container
    const firstChild = this.el.nativeElement.parentNode.firstChild;
    if (firstChild) {
      this.renderer.insertBefore(this.el.nativeElement.parentNode, this.leftArrow, firstChild);
    } else {
      // If no children are present, append it normally
      this.renderer.appendChild(this.el.nativeElement.parentNode, this.leftArrow);
    }
    this.renderer.appendChild(this.el.nativeElement.parentNode, this.rightArrow);

    this.hideArrows();
  }

  private showArrows() {
    this.renderer.setStyle(this.leftArrow, 'display', 'block');
    this.renderer.setStyle(this.rightArrow, 'display', 'block');
  }

  private hideArrows() {
    this.renderer.setStyle(this.leftArrow, 'display', 'none');
    this.renderer.setStyle(this.rightArrow, 'display', 'none');
  }

  private scrollLeft() {
    this.el.nativeElement.scrollBy({
      left: -200,
      behavior: 'smooth'
    });
  }

  private scrollRight() {
    this.el.nativeElement.scrollBy({
      left: 200,
      behavior: 'smooth'
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkForScroll();
  }
}

